// Forced polyfill that is not automatically added by the babel-config > useBuiltIns: 'usage'
// Needed for IE11 support

// eslint-disable-next-line no-unused-vars
//import Symbol from '~/core-js/modules/es.symbol'
import '~/core-js/modules/es.array.from'
import '~/core-js/modules/es.promise'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { clientsideSetup } from '@/_framework/global-clientside'
import '@/style/epi6.scss'
import throttle from 'lodash.throttle'
import Vue from 'vue'
Vue.config.productionTip = false

// #region DIRECTIVES AND PLUGINS
// Scrolling by mouse or touch
import VueDragscroll from 'vue-dragscroll'
Vue.use(VueDragscroll)
// #endregion

// #region VUE COMPONENTS
// Common external components
import SvgIcon from 'vue-svgicon'

import "@/vue/components/icons/Alerts/Warning_illustrative"
import "@/vue/components/icons/Alerts/Question"
import "@/vue/components/icons/AppStore/AppStore"
import "@/vue/components/icons/AppStore/GooglePlay"
import "@/vue/components/icons/Climate/ClimateGoals"
import "@/vue/components/icons/Communication/Contact"
import "@/vue/components/icons/Communication/Email"
import "@/vue/components/icons/Controls/Close"
import "@/vue/components/icons/Controls/Locked"
import "@/vue/components/icons/Controls/Rate"
import "@/vue/components/icons/Controls/Heart"
import "@/vue/components/icons/Controls/Settings"
import "@/vue/components/icons/Cooking/Recipe"
import "@/vue/components/icons/Logos"
import "@/vue/components/icons/Misc/Placeholder"
import "@/vue/components/icons/Navigation/AngleDown"
import "@/vue/components/icons/Navigation/AngleUp"
import "@/vue/components/icons/Navigation/AngleLeft"
import "@/vue/components/icons/Navigation/AngleRight"
import "@/vue/components/icons/Navigation/Home"
import "@/vue/components/icons/Navigation/Menu"
import "@/vue/components/icons/Navigation/Search"
import "@/vue/components/icons/Search/Search"
import "@/vue/components/icons/Services/Bank"
import "@/vue/components/icons/Services/Insurance"
import "@/vue/components/icons/Services/Pharmacy"
import "@/vue/components/icons/Shop/AccountBalance"
import "@/vue/components/icons/Shop/Bonus"
import "@/vue/components/icons/Shop/CreditCard"
import "@/vue/components/icons/Shop/Offer"
import "@/vue/components/icons/Shop/Shop"
import "@/vue/components/icons/Shop/ShoppingBag"
import "@/vue/components/icons/Shop/ShoppingCart"
import "@/vue/components/icons/Shop/ShoppingList"
import "@/vue/components/icons/Social/Facebook"
import "@/vue/components/icons/Social/instagram"
import "@/vue/components/icons/Social/Twitter"
import "@/vue/components/icons/Social/YouTube"
import "@/vue/components/icons/Time/WeeklyPlan"
import "@/vue/components/icons/Users/User"
import "@/vue/components/icons/Positions/MyPosition"
import "@/vue/components/icons/Controls/Edit"

Vue.use(SvgIcon)

import NoSSR from 'vue-no-ssr'
Vue.component('no-ssr', NoSSR)


// On page edit plugin that enables that exposes the computed isEditable variable on all vue instances
import OnPageEditPlugin from '@/vue/plugins/onPageEditPlugin'
Vue.use(OnPageEditPlugin)

import IcaHeader from '@/vue/components/topNav/topNav'
import IcaFooter from '@/vue/components/footerNav/footerNav'

Vue.component('IcaHeader', IcaHeader)
Vue.component('IcaFooter', IcaFooter)

import IE11Attribute from '../mixins/IE11Attribute'
// #endregion
import { getConfig } from '../envConfig'

export function createApp (d, componentId, inEditMode, isLoggedIn) {
  const id = parseInt(componentId) ? `content_${componentId}` : componentId
  const tpl = `<${d.component} v-bind="initdata" data-componentid="${id}"></${d.component}>`
  const sizes = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl']

  const app = new Vue({
    mixins: [IE11Attribute],
    data: {
      initdata: d,
      editMode: inEditMode,
      isLoggedIn: isLoggedIn,
      currentSize: 'sm',
      envConfig: getConfig()
    },
    mounted () {
      this.setCurrentViewportSize()
      window.addEventListener("resize", throttle(() => {
         this.setCurrentViewportSize()
      }))
    },
    methods: {
      // current size is Less than or equal to
      currentSizeLte (size) {
        return sizes.indexOf(this.currentSize) <= sizes.indexOf(size)
      },
      // current size is Greater than or equal to
      currentSizeGte (size) {
        return sizes.indexOf(this.currentSize) >= sizes.indexOf(size)
      },
      // current size is Equal to
      currentSizeEquals (size) {
        return sizes.indexOf(this.currentSize) === sizes.indexOf(size)
      },
      setCurrentViewportSize () {
        if (window.matchMedia("(min-width: 1280px)").matches) {
          this.currentSize = 'xl'
        } else if (window.matchMedia("(min-width: 1024px)").matches) {
          this.currentSize = 'lg'
        } else if (window.matchMedia("(min-width: 768px)").matches) {
          this.currentSize = 'md'
        } else if (window.matchMedia("(min-width: 480px)").matches) {
          this.currentSize = 'sm'
        } else if (window.matchMedia("(min-width: 375px)").matches) {
          this.currentSize = 'xs'
        } else {
          this.currentSize = 'xxs'
        }
      }
    },
    template: tpl,

  })

  return app
}

clientsideSetup()

let ssrComponents = document.querySelectorAll('[data-server-rendered]')
window.vueinstances = []
ssrComponents.forEach(component => {
  let componentId = component.getAttribute('data-componentid')
  const componentData = window._vueContext[componentId]
  if (componentData) {
    const app = createApp(componentData.data, componentId, false /*editmode*/)
    app.$mount(component)
    window.vueinstances[componentId] = app
  } else {
    console.warn('Could not load component: ', component)
  }
})

